import {
    CLEAR_LOYALTY_USERS,
    LOAD_LOYALTY_USERS,
    LOAD_USER_PROMOCODES,
    LOADING
} from "../../types";
import axios from '../../../utils/AxiosUtils';
import MessageUtils from "../../../utils/MessageUtils";
import i18n from "../../../i18next";

export const loadLoyaltyUsers = (searchQuery) => {
    return (dispatch) => {
        dispatch({type: LOADING, payload: true});
        const url = `/promotion/loyalty-search`;
        let params = {};

        for (let [key, value] of Object.entries(searchQuery)) {
            if (value !== '') {
                params = { ...params, [key]: value }
            }
        }

        axios().get(url, {
            params: params
        })
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: LOAD_LOYALTY_USERS, payload: response.data });
            })
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:loyaltyActions.loadLoyaltyUsersFailure')))
    }
};

export const loadCustomerCodes = (restaurantId, customerId) => {
    return (dispatch) => {
        dispatch({type: LOADING, payload: true});
        const url = `/restaurant/${restaurantId}/loyalty-codes`;
        const params = { customerId: customerId };

        axios().get(url, {
            params: params
        })
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: LOAD_USER_PROMOCODES, payload: response.data });
            })
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:loyaltyActions.loadLoyaltyUserCodesFailure')))
    }
};

export const disableCode = (codeId, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });
        const url = `/promo-code/${codeId}/disable`;

        axios().put(url, {})
            .then(response => {
                callback();
                dispatch({ type: LOADING, payload: false });
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:loyaltyActions.disableCodeSuccess'));
            })
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:loyaltyActions.disableCodeFailure')))
    }
};

export const clearLoyaltyUsers = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_LOYALTY_USERS });
    }
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/loyalty/LoyaltyUsersActions.js